import React from 'react';
import SgsstCrudPage from '../components/SgsstCrudPage';
import { sgsstPlan } from '../services/api';

const yNow = new Date().getFullYear();
const CICLO = { planear: 'Planear', hacer: 'Hacer', verificar: 'Verificar', actuar: 'Actuar' };
const ESTADO = { programada: 'Programada', en_proceso: 'En proceso', cumplida: 'Cumplida' };

export default function SgsstPlan() {
  return (
    <SgsstCrudPage
      title="Plan anual de trabajo"
      sub="Cronograma de actividades del SG-SST por ciclo PHVA."
      newLabel="+ Nueva actividad"
      api={sgsstPlan}
      vacio={{ anio: yNow, ciclo: 'planear', actividad: '', responsable: '', fecha_inicio: '', fecha_fin: '', recursos: '', estado: 'programada' }}
      columns={[
        { k: 'anio', h: 'Año', mono: true }, { k: 'ciclo', h: 'Ciclo', map: CICLO }, { k: 'actividad', h: 'Actividad', strong: true },
        { k: 'responsable', h: 'Responsable' }, { k: 'fecha_fin', h: 'Límite', fmt: 'date' }, { k: 'estado', h: 'Estado', map: ESTADO },
      ]}
      fields={[
        { k: 'anio', l: 'Año', type: 'number' }, { k: 'ciclo', l: 'Ciclo PHVA', type: 'select', opts: Object.entries(CICLO) },
        { k: 'actividad', l: 'Actividad', type: 'textarea', full: true }, { k: 'responsable', l: 'Responsable', type: 'text' },
        { k: 'recursos', l: 'Recursos', type: 'text' }, { k: 'fecha_inicio', l: 'Inicio', type: 'date' }, { k: 'fecha_fin', l: 'Fin', type: 'date' },
        { k: 'estado', l: 'Estado', type: 'select', opts: Object.entries(ESTADO) },
      ]}
    />
  );
}
